<template>
  <div class="container-fluid">

    <div class="row">
      <div class="col-12 col-md-6">{{ __('lang.building_data.building_type') }}:</div>
      <div class="col-12 col-md-6">
        {{ building_type_options[building.type].text }}
      </div>
      <div class="col-12 col-md-6">{{ __('lang.kwl.overview.building_location') }}:</div>
      <div class="col-12 col-md-6">
        {{ building_location_options[building.location].text }}
      </div>
      <div class="col-12 col-md-6">{{ __('lang.kwl.building_data.heat_protection') }}:</div>
      <div class="col-12 col-md-6">
        {{ building_heat_protection_options.text }}
      </div>
      <div v-if="configuration.norms_id == 1" class="col-12 col-md-6">
        {{ __('lang.kwl.building_data.occupancy') }}:
      </div>
      <div v-if="configuration.norms_id == 1" class="col-12 col-md-6">
        {{ building_occupancy_options.text }}
      </div>

      <div class="col-12 col-md-6">{{ __('lang.kwl.building_data.airtightness') }}:</div>
      <div class="col-12 col-md-6">{{ building_airtightness_options[building.airtightness].text }}:
        {{ __('lang.output.airchange') }}: {{ building.airExchange }} h-1
      </div>
    </div>
    <h5 class="my-3">{{ __('lang.building_data.geometry') }}</h5>
    <div class="row">
      <div class="col-12 col-md-6">{{ __('lang.output.usage.unit') }}:</div>
      <div class="col-12 col-md-6">{{ unit.space }} m2</div>
      <div class="col-12 col-md-6">{{ __('lang.output.room.height') }}:</div>
      <div class="col-12 col-md-6">{{ unit.height }} m</div>
      <div class="col-12 col-md-6">{{ __('lang.output.air.volume.usage.unit') }}:</div>
      <div class="col-12 col-md-6">{{ unit.volume }} m3</div>
    </div>
    <div v-if="configuration.norms_id==1">
      <h5 class="my-3">{{ __('lang.output.calculation') }}</h5>

      <div class="row">
        <div class="col-12 col-md-6">{{ __('lang.output.moisture.protection') }}:</div>
        <div class="col-12 col-md-6">{{ unit.moisureProtection }} m3/h</div>
        <div class="col-12 col-md-6">{{ __('lang.output.infiltration.text') }}:</div>
        <div class="col-12 col-md-6">{{ unit.infiltration }} m3/h</div>
        <div class="col-12 col-md-6 mt-2">{{ __('lang.output.measures.text') }}:</div>
        <div class="col-12 col-md-6 mt-2">
          <span v-if="unit.infiltration < unit.moisureProtection">{{
              __('lang.kwl.building_geometry_result.yes')
            }}</span>
          <span v-else-if="unit.infiltration > unit.moisureProtection && unit.windowless == true">{{
              __('lang.kwl.building_geometry_result.yes_windowless')
            }}</span>
          <span v-else>{{ __('lang.kwl.building_geometry_result.no') }}</span>
        </div>
      </div>

    </div>

    <!--      <h5 class="my-3">{{ __('lang.kwl.overview.building_data') }}</h5>-->
    <!--        <table striped class="table">
                <thead>
                    <th>{{ __("lang.kwl.building_data.building_type") }}</th>
                    <th>{{ __("lang.kwl.overview.building_location") }}</th>
                    <th>{{ __("lang.kwl.building_data.heat_protection") }}</th>
                </thead>
                <tbody>
                    <tr>
                        <td>{{ building_type_options[building.type].text }}</td>
                        <td>{{ building_location_options[building.location].text }}</td>
                        <td>
                            {{ building_heat_protection_options.text }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div v-if="unit.fireplace">
                                {{ __("lang.kwl.overview.fireplace") }}
                            </div>
                            <div v-else>{{ __("lang.kwl.overview.no_fireplace") }}</div>
                        </td>
                        <td>{{ __('lang.output.building.height') }}: {{ building_height_options[building.height].text }}</td>
                        <td>
                            <p class="border-gray-50 border-bottom pb-2" v-if="unit.occupancy == 1">
                                {{ __("lang.kwl.building_data.height") }}
                            </p>
                            <p class="border-gray-50 border-bottom pb-2" v-else>
                                {{ __("lang.kwl.building_data.low") }}
                            </p>
                            <div>
                                {{ building_airtightness_options[building.airtightness].text }}
                            </div>
                            <div>{{ __('lang.kwl.building_data.n_50') }}: {{ building.airExchange }} h-1</div>
                        </td>
                    </tr>
                </tbody>
            </table>-->
  </div>
</template>

<script>
import Building from '@models/building/Building'
import Unit from '@models/building/Unit'
import {setLabels, getLangKey} from '@services/helpers/langHandler'
import Configuration from "@models/project/Configuration";

export default {
  props: ['index', 'id'],
  data() {
    return {}
  },

  methods: {
    getLangKey: getLangKey,
    setLabels: setLabels,
  },
  computed: {
    building() {
      return Building.query().first()
    },
    unit() {
      return Unit.query().where('id', this.id).withAllRecursive().first()
    },
    building_type_options: {
      get() {
        return this.setLabels(this.$store.state.inputs.building_type)
      },
    },
    building_location_options: {
      get() {
        return this.setLabels(this.$store.state.inputs.building_location)
      },
    },
    building_heat_protection_options: {
      get() {
        var options = this.setLabels(this.$store.state.inputs.building_heat_protection)
        return options.find((e) => e.value == this.building.heatProtection)
      },
    },
    building_occupancy_options: {
      get() {
        var options = this.setLabels(this.$store.state.inputs.building_occupancy)
        return options.find((e) => e.value == this.unit.occupancy)
      },
    },
    building_airtightness_options: {
      get() {
        return this.setLabels(this.$store.state.inputs.building_airtightness)
      },
    },
    building_height_options: {
      get() {
        return this.setLabels(this.$store.state.inputs.building_height)
      },
    },
    configuration() {
      return Configuration.query().with(['project']).first()
    },
  },
}
</script>
